import React, { useState, useEffect } from "react";
import { Col, Statistic, Typography } from "antd";
import map from "lodash/map";
import get from "lodash/get";
import getTemplateTypeGraphConfig from "./getTemplateTypeGraphConfig";
import { graphEventHandler } from "../../utilities/graph";

const { Title } = Typography;

const GraphGrid = ({
  graphId,
  stats,
  statistics,
  label,
  type,
  meta,
  selectedTemplate,
  filter
}) => {
  const [graph, setGraph] = useState(undefined);
const templateType = get(filter, "templateType")
  useEffect(() => {
    setGraph(
      getTemplateTypeGraphConfig(graphId, type, meta, templateType)
    );
  }, []);

useEffect(() => {
  if (graph && get(selectedTemplate, "template")) {

    graph.render();
    const handler = (event) =>
      graphEventHandler(event, selectedTemplate, stats, filter, type);
    graph.on("element:click", handler);

    return () => {
      graph.off("element:click", handler); 
    };
  }
}, [graph, selectedTemplate, stats, filter, type]);

  useEffect(() => {
    if (stats.length > 0 && graph) {
      graph.changeData(stats);
    }
  }, [graph, stats]);
  return (
    <Col xl={24} className="mb-10 graph-container">
      <div className=" flex flex-row mb-4 ">
        <div className="items-center w-1/3">
          <Title level={2}>{label}</Title>
        </div>
        <div className=" justify-end space-x-10 flex flex-row  w-2/3">
          {map(statistics, (stats) => (
            <Statistic
              groupSeparator=""
              title={get(stats, "label")}
              value={get(stats, "value")}
              key={crypto.randomUUID()}
            />
          ))}
        </div>
      </div>
      <div id={`graph-${graphId}`} className="h-96" />
    </Col>
  );
};

export default GraphGrid;
